module.exports = __webpack_public_path__ + "img/unload-1-1.8781be95.png";